import React from "react";
import T from "prop-types";
import TableDetailRow from "MODULES/shared/components/DetailTable/Detail";
import { PoCode } from "MODULES/shared/components";
import { get } from "lodash";
import { Link } from "react-router-dom";

function PurchaseDetails({ inventory }) {
  if (inventory.purchase_order_code) {
    return (
      <React.Fragment>
        <TableDetailRow
          label="Recent PO#"
          renderIfPresent
          value={<PoCode inventory={inventory} />}
        />
        <TableDetailRow
          label="Vendor Name"
          renderIfPresent
          value={inventory.po_vendor_name}
        />
      </React.Fragment>
    );
  }

  if (get(inventory, "lot_details.code")) {
    return (
      <React.Fragment>
        <TableDetailRow
          label="Lot"
          value={
            <Link to={`/lots/${get(inventory, "lot_details.uuid")}`}>
              {get(inventory, "lot_details.code")}
            </Link>
          }
          renderIfPresent
        />
        <TableDetailRow
          label="Lot Vendor"
          value={
            <Link
              to={`/companies/${get(inventory, "lot_details.company.uuid")}`}
            >
              {get(inventory, "lot_details.company.name")}
            </Link>
          }
          renderIfPresent
        />
      </React.Fragment>
    );
  }

  return null;
}

export default PurchaseDetails;

PurchaseDetails.propTypes = {
  inventory: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/PurchaseDetails.jsx